import { Component, OnChanges, Input, Output, EventEmitter, Directive } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { Router } from '@angular/router';
import { DialogDocuments } from '../../dialog/documents/dialog.component.documents';
import { MatDialog, MatDialogRef } from '@angular/material/dialog'

import { DocumentsService } from '../../services/documents-service/documents.service';
import { IFLDocuments } from '../documents.interfaces';

@Directive()
export class BaseDocumentsListComponent implements OnChanges {
  @Input('elementList') elementList: any;
  @Output('requestRows') requestRows = new EventEmitter();

  public activeFilters: any = {};
  public currentOrdering: any = {};
  public orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number;

  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  public showFilters: boolean = true;

  public orderingParameters: any;
  public error: string = '';
  private documentModel: IFLDocuments = {
     'id': 'NEW', 
     'titol': '', 
     'descripcio': '', 
     'tipus': '', 
     'data_doc': '', 
     'fitxer': '', 
     'file': (new Date()).toISOString().slice(0, 10)
  };
  public documentsData: IFLDocuments;
  public showDialog: boolean = false;
  public showAsyncProgress: boolean = false;

  private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listService.currentPage * this.listService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listService.rowsPerPage - 1, this.elementList.registers);
  }

  private requestRowsToParent(): void {
    this.requestRows.emit({
      skip : this.firstRegisterShown - 1,
      limit: this.listService.rowsPerPage,
      conds: { },
      filters: this.activeFilters,
      ordering: this.currentOrdering
    });
  }

  public computeActiveFilters($event) {
    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listService.currentPage * this.listService.rowsPerPage;
    this.requestRowsToParent();
  }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  public requestPrevious(): void {
    this.listService.currentPage = Math.max(0, this.listService.currentPage - 1);
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public requestNext(): void {
    this.listService.currentPage = Math.min(Math.floor(this.elementList.registers / this.listService.rowsPerPage), this.listService.currentPage + 1);
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public gotoPage(page: number): void {
    this.listService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public navigateToProject(project) {
    this.router.navigate([this.routeKey, project.codi]);
  }

  public setRowPerPage(rowsPerPage: number) {
    this.listService.rowsPerPage = rowsPerPage;
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
    this.showFilters = !this.showFilters;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, public listService: DocumentsService, private router: Router, public tableFields, private routeKey: string,
              public documentsFilters: Array<any>,public ordreCamps: Array<any>, public dialog:MatDialog) {
    this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    for(var i=0;i<ordreCamps.length;i++){this.orderingParameters[ordreCamps[i].key] = ordreCamps[i].sort;this.cycleOrdering(ordreCamps[i].key);}
  }

  public editDocument(document: IFLDocuments): void {
    this.documentsData = Object.assign(
      {},
      this.documentModel,
      document
    );
    let dialogFactRef=this.dialog.open(DialogDocuments, {disableClose: true, height: '450px', data: this.documentsData })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.documentsData = results;
      this.addOrUpdate();
    });
  }

  public addDocument(): void {
    this.documentsData = Object.assign(
      {},
      this.documentModel,
      { id : 'NEW' }
    );
    let dialogFactRef=this.dialog.open(DialogDocuments, {disableClose: true, height: '450px', data: this.documentsData })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.documentsData = results;
      this.addOrUpdate();
    });
    //this.showDialog = true;
  }

  public addOrUpdate(): void {
    if (this.documentsData.id  == 'NEW') {
      this.listService.createDocument(this.documentsData)
        .subscribe(newContacte => {console.log("S'ha pujat la fitxa del document.");
          //this.router.navigate(['/documents']);
          window.location.reload();
        });
    } else {
      this.listService.updateDocument(<number> this.documentsData.id, this.documentsData)
        .subscribe(updatedDoc => {console.log("S'han desat els canvis.");
          //this.router.navigate(['documents']);
          window.location.reload();
        });
    }
  }

  public deleteDocument(id): void {
    if(confirm("Confirma l'esborrat del document")){
      this.listService.deleteDocument(<number> id)
      .subscribe(deleted => {
        console.log("S'ha esborrat el document");
        window.location.reload();
        //this.router.navigate(['documents']);
      },
         err => console.log(err)
      );
    }
  }

  ngOnChanges(changes: any): void {
    const newElementList = changes.elementList.currentValue;
    if (newElementList)this.computeDisplayedRows();
  }
}

@Component({
  selector: 'mcrit-gestio-documents-list',
  templateUrl: 'documents-list.component.html',
  styleUrls: ['documents-list.component.css'],
  providers: []
})
export class DocumentsListComponent extends BaseDocumentsListComponent {
  @Input('elementList') elementList: any;
  @Output('requestRows') requestRows = new EventEmitter();

  public title: string = 'Documents';
  public isDate(field: string): boolean { return (field === 'data_doc'); }

  ngOnInit() { this.computeActiveFilters({});  }

  constructor(public translate: TranslateService, public languageService: LanguageService, listService: DocumentsService,router: Router, dialog:MatDialog) {
    super( translate, languageService, listService, router, [
      ['titol', 'Títol'],
      ['tipus', 'Tipus'],
      ['data_doc', 'Data'],
      ['fitxer', 'Fitxer']
    ], 'documents', [
      {
      inputs: [
        {
          name: 'Tipus',
          type: 'checkbox',
          values: [ ]
        }
      ]
    },
    {   inputs: [ 
          {
            name: 'text',
            type: 'text',
            values: [
              {
                text: 'Títol',//Text a mostrar label
                name: 'titol', //Camp de la base de dades
                autocomplete: 'docTitol',//Crida per obtenir els valors si autocomplete
                value: listService.getSearchValues('titol')//valor a mostrar
              },
              {
                text: 'Tipus',
                name: 'tipus',
                autocomplete: 'docTipus',//Crida per obtenir els valors si autocomplete
                value: listService.getSearchValues('tipus')//valor a mostrar
              },
              {
                text: 'Data',
                name: 'data',
                value: ''
              }
            ]
          }
        ]
      }
    ],[{}], dialog);
  };
}
